import React, { useMemo } from 'react';
import { Table } from 'react-bootstrap'
import MarcatoreQuotaTabella from './MarcatoreQuotaTabella';
import MarcatoreQuotaTabellaBF from './MarcatoreQuotaTabellaBF';
import { MarcatoriConst } from '../../constants';
import { useDispatch } from 'react-redux';
import * as MarcatoriActions from '../../redux/marcatori/actions';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { getConcessionariAvvisoVisible, getConcessionariVisible } from '../../utils/marcatori/odds_function';

// oggetti di stile costanti: venivano riallocati per ogni cella ad ogni render
const STILE_CLICCABILE = { cursor: "pointer" }
const STILE_VUOTO = {}

const RowMarcatore = (props) => {
  // const [visible, setVisible] = useState(true)
  const marcatore = props.marcatore
  const evento_id = props.evento_id
  const classColumns = props.classColumns
  const quoteEvento = props.quoteEvento

  const dispatch = useDispatch()

  /*useEffect(() => {
    setVisible(props.visibilitaMarcatore)
  }, [props.visibilitaMarcatore]);*/

  const alert_bf_attivo = props.alert_abilitati['BF']['abilitato']
  const alert_avg_attivo = props.alert_abilitati['AVG']['abilitato']

  // gli elenchi non dipendono dalla cella: prima venivano ricostruiti da zero per ogni
  // cella MAX Odds, dentro il doppio ciclo marcatori x specialita
  const concessionari_avviso_visibili = useMemo(
    () => new Set(getConcessionariAvvisoVisible(props.concessionari)), [props.concessionari])
  const concessionari_visibili = useMemo(
    () => new Set(getConcessionariVisible(props.concessionari)), [props.concessionari])

  // ritorna l'oggetto quota del marcatore per la specialita e il concessionario indicati,
  // oppure undefined se non presente
  const getQuota = (spec, concessionario_codice) => {
    const quote_specialita = quoteEvento && quoteEvento[marcatore.specialita[spec.id]]
    return quote_specialita && quote_specialita[concessionario_codice]
  }


  const getCellaQuota = (concessionario, valore, valore_2) => {
    if (concessionario == MarcatoriConst.CONCESSIONARIO_BETFAIR) {
      return <MarcatoreQuotaTabellaBF quota_2={valore_2} quota={valore}></MarcatoreQuotaTabellaBF>
    } else {
      return <MarcatoreQuotaTabella quota={valore}></MarcatoreQuotaTabella>
    }
  }

  return (
    marcatore.visible && marcatore.enabled &&
    <div className={classColumns + ' card my-1 mx-1'} key={marcatore.quota_descrizione + evento_id + '1'} >
      <div key={marcatore.quota_descrizione + evento_id + '3'} className={'fw-bold fs-marcatore row'}>
        <div className='col-3 text-nowrap overflow-hidden ps-1'>
          <span style={{ cursor: 'pointer' }}><i className="bi bi-x-lg p-1" onClick={() => {
            confirmAlert({
              title: '',
              message: 'Sicuro di voler eliminare il marcatore?',
              buttons: [
                {
                  label: 'Si',
                  onClick: () => {
                    dispatch(MarcatoriActions.setStateEnabledPlayer(props.evento, marcatore, false))
                  }

                },
                {
                  label: 'No',
                }
              ]
            }
            );
          }}
            title='Elimina marcatore'
          ></i></span>
          {/* <i className={(marcatore.open)? 'bi bi-arrows-collapse mx-1' : 'bi bi-arrows-expand mx-1'}  onClick = {()=>{
                          dispatch(MarcatoriActions.setStateOpenMarcatore(!marcatore.open, props.evento, marcatore));
                  }}></i> */}
          <span title={(marcatore.open ? 'Chiudi marcatore' : 'Apri marcatore')} style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => {
            dispatch(MarcatoriActions.setStateOpenMarcatore(!marcatore.open, props.evento, marcatore));
          }}>
            {marcatore.quota_descrizione}
            <span style={{fontWeight: 'normal'}}>{marcatore.team_descrizione && ` (${marcatore.team_descrizione})`}</span>
            </span>
        </div>
        <div className='col-9'>
          {!marcatore.open && <>
            <Table className='table-borderless mb-0 w-auto' align={'right'} striped="">
              <tbody key={marcatore.quota_descrizione + evento_id + '5'}>
                <tr>
                  <td width={150} className='align-middle fs-quote text-muted pe-3' align={'right'}>
                    <span
                      className='bi bi-arrows-expand'
                      style={{ float: 'right', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => {
                        dispatch(MarcatoriActions.setStateOpenMarcatore(!marcatore.open, props.evento, marcatore));
                      }}
                      title='Apri marcatore'
                    ></span>
                  </td>
                  {props.specialita && props.specialita.map((spec) => {
                    const quota_max = getQuota(spec, MarcatoriConst.CONCESSIONARIO_VIRTUALE)
                    const concessionario_max = quota_max && quota_max['concessionario']
                    const MaxOdds_avviso_visible = Boolean(concessionario_max
                      && concessionari_avviso_visibili.has(concessionario_max)
                      && concessionari_visibili.has(concessionario_max))
                    const alert_max = quota_max ? quota_max['alert'] : 0
                    const alert_max_bf = Boolean(alert_max & 1) && MaxOdds_avviso_visible && alert_bf_attivo
                    const alert_max_avg = Boolean(alert_max & 2) && MaxOdds_avviso_visible && alert_avg_attivo
                      && (!(alert_max & 1) || !alert_bf_attivo)
                    const max_cliccabile = Boolean(alert_max_bf || alert_max_avg)
                    return (
                      spec.visible &&
                      <td

                        key={MarcatoriConst.CONCESSIONARIO_VIRTUALE + spec.id + evento_id}
                        className={'fs-specialita fs-quote text-center'
                          + (alert_max_bf ? ' bg-danger text-warning' : '')
                          + (alert_max_avg ? ' bg-warning text-danger' : '')}
                        onClick={() => {
                          if (max_cliccabile) {
                            dispatch(MarcatoriActions.setStateOpenMarcatore(!marcatore.open, props.evento, marcatore));
                          }
                        }}
                        style={max_cliccabile ? STILE_CLICCABILE : STILE_VUOTO}
                        width={70}>
                        {quota_max && quota_max['value'] > 0 ?
                          <MarcatoreQuotaTabella quota={quota_max['value']}></MarcatoreQuotaTabella>
                          : '-'
                        }
                      </td>

                    );
                  }

                  )}
                </tr>
              </tbody>
            </Table>
          </>}
          {marcatore.open && <>
            <Table className='table-borderless mb-0 w-auto' align={'right'} striped="columns">

              <tbody key={marcatore.quota_descrizione + evento_id + '5'}>
                <tr style={{ borderBottom: "1px solid #ccc" }}>
                  <td width={90} style={{ borderRight: "1px solid #ccc" }} className='text-center fs-quote text-muted pe-3'>
                    <span
                      className='bi bi-arrows-collapse'
                      style={{ float: 'right', cursor: 'pointer', userSelect: 'none' }}
                      onClick={() => {
                        dispatch(MarcatoriActions.setStateOpenMarcatore(!marcatore.open, props.evento, marcatore));
                      }}
                      title='Chiudi marcatore'
                    ></span>
                  </td>
                  {props.specialita && props.specialita.map((spec) =>
                    spec.visible && <td key={spec.id + evento_id} className='text-center fw-normal text-muted align-middle fs-quote fs-titolo'>
                      <div style={{width: (props.rowHeaderOpen) ? "50px" : "70px"}}>
                        {spec.descrizione}
                      </div>
                    </td>
                  )}
                </tr>


                {props.concessionari && props.concessionari.map((concessionario) =>
                  concessionario.visible && <tr key={concessionario.concessionario_codice + evento_id + '1'}>
                    <td key={concessionario.concessionario_codice + evento_id + '2'} width={90} style={{ borderRight: "1px solid #ccc" }} className='align-middle fw-normal fs-concessionario text-muted pe-3' align={'right'}> {concessionario.concessionario_descrizione}</td>
                    {props.specialita && props.specialita.map((spec) => {
                      // la quota viene letta una volta sola: prima la stessa catena di accessi
                      // veniva ripercorsa fino a dodici volte per ogni cella
                      const quota = getQuota(spec, concessionario.concessionario_codice)
                      const alert_cella = quota ? quota['alert'] : 0
                      const avvisi_visibili = concessionario.avvisi_visible
                      const alert_bf = Boolean(alert_cella & 1) && alert_bf_attivo && avvisi_visibili
                      const alert_avg = Boolean(alert_cella & 2) && alert_avg_attivo && avvisi_visibili
                        && (!(alert_cella & 1) || !alert_bf_attivo)
                      const cliccabile = Boolean(alert_bf || alert_avg)
                      return (
                        spec.visible && <td
                          title={(quota ? quota['quota_descrizione'] : '')}
                          key={concessionario.concessionario_codice + spec.id + evento_id}
                          className={'fs-specialita fs-quote  text-center'
                            + (alert_bf ? ' bg-danger text-warning' : '')
                            + (alert_avg ? ' bg-warning text-danger' : '')}
                          onClick={() => {
                            if (cliccabile) {
                              dispatch(MarcatoriActions.setStateOpenMarcatore(!marcatore.open, props.evento, marcatore));
                            }
                          }}
                          style={cliccabile ? STILE_CLICCABILE : STILE_VUOTO}

                          width={(props.rowHeaderOpen) ? 50 : 70}>
                          {quota ?
                            getCellaQuota(concessionario.concessionario_codice, quota['value'], quota['value_2'])
                            : ''}
                        </td>
                      );
                    }
                    )}
                  </tr>
                )}
              </tbody>
            </Table>
          </>}
        </div>
      </div>
    </div>
  );
}

// Il marcatore si ri-renderizza solo se cambia il suo oggetto, una delle impostazioni globali,
// oppure una delle quote che lo riguardano. Grazie al copy-on-write nel reducer viene toccato
// un solo marcatore per quota, invece di tutti quelli dell'evento.
const stessePropsMarcatore = (prev, next) => {
  if (prev.marcatore !== next.marcatore
    || prev.renderToken !== next.renderToken
    || prev.concessionari !== next.concessionari
    || prev.specialita !== next.specialita
    || prev.alert_abilitati !== next.alert_abilitati
    || prev.classColumns !== next.classColumns
    || prev.tipoVisualizzazione !== next.tipoVisualizzazione
    || prev.rowHeaderOpen !== next.rowHeaderOpen
    || prev.evento_id !== next.evento_id) {
    // prev.evento non viene confrontato di proposito: l'oggetto evento cambia identita' ad ogni
    // quota, e confrontarlo farebbe ri-renderizzare tutti i marcatori dell'evento. Viene usato
    // solo per le action, che ora cercano l'evento per evento_id (vedi indiceEvento nel reducer)
    return false
  }
  // confronto delle sole quote del marcatore: S riferimenti invece di C x S celle ricostruite
  const specialita_marcatore = next.marcatore.specialita
  for (const chiave in specialita_marcatore) {
    const quota_id = specialita_marcatore[chiave]
    const quota_prev = prev.quoteEvento ? prev.quoteEvento[quota_id] : undefined
    const quota_next = next.quoteEvento ? next.quoteEvento[quota_id] : undefined
    if (quota_prev !== quota_next) {
      return false
    }
  }
  return true
}

export default React.memo(RowMarcatore, stessePropsMarcatore);